import script from "./AppSelectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSelectButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppSelectButton.vue?vue&type=style&index=0&id=4d7caa64&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7caa64"]])

export default __exports__